export enum Confirmation {
  Confirmed = 'confirmed',
  Cancelled = 'cancelled',
  Deleted = 'deleted',
  ToBeDone = 'tbd',
}
